import { useAppDispatch, useAppSelector } from "@/config/store";
import { Button } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { IEdoQuestion } from "@/shared/model/edo-question.model";
import { deleteEntity } from "@/shared/reducers/entities/edo-question.reducer";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { useEffect } from "react";
import { Translate } from "react-jhipster";

interface IDeleteQuestionProps {
  question: IEdoQuestion;
  open: boolean;
  onClose: () => void;
}

const DeleteQuestion = (props: IDeleteQuestionProps) => {
  const dispatch = useAppDispatch();
  const { updateSuccess } = useAppSelector<EntityState<IEdoQuestion>>(
    (state) => state.edoQuestion
  );

  const { question, open, onClose: handleClose } = props;

  const confirmDelete = () => {
    dispatch(deleteEntity(question.id));
  };

  useEffect(() => {
    if (open && updateSuccess) {
      handleClose();
    }
  }, [updateSuccess, open, handleClose]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Translate contentKey="entity.delete.title">
              Confirm delete operation
            </Translate>
          </DialogTitle>
        </DialogHeader>
        <p className="text-body text-[var(--color-mockup-text-mid)]">
          <Translate contentKey="edocendoApp.edoQuestion.delete.question">
            Are you sure you want to delete this EdoQuestion?
          </Translate>
        </p>
        <DialogFooter className="gap-2 pt-4">
          <Button variant="outline" onClick={handleClose}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            <Translate contentKey="entity.action.delete">Delete</Translate>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteQuestion;
